
import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from '../../OutOfStock.translations'

export default {
  components: {
    RevPopover,
    RevTooltip,
  },
  props: {
    price: {
      type: String,
      required: true,
    },
    reference: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
  },
}
